import React from 'react';
import StaticPage, { Section, CardGrid } from './StaticPage';

export default function SuccessStories() {
  return (
    <StaticPage title="Success Stories" subtitle="Real landlords and students sharing their RentalX experiences.">
      <Section title="Student Stories">
        <div className="space-y-6">
          {[
            { name: 'Priya S.', uni: 'University of Melbourne', quote: 'I found my apartment in Carlton three weeks before arriving in Australia. The landlord was verified and the photos matched exactly. Moving to a new country is stressful enough — having housing sorted in advance made such a difference.' },
            { name: 'Li Wei C.', uni: 'UNSW Sydney', quote: 'As an international student from China, I was worried about being scammed. RentalX\'s verified badge gave me the confidence to book from overseas. My room in Kensington was exactly as described and the process was smooth.' },
            { name: 'Ahmed K.', uni: 'University of Queensland', quote: 'I used RentalX to find a flatshare in St Lucia near UQ. The filtering by distance to university was super helpful. Found three housemates through the platform and we\'re still living together two years later!' },
          ].map((s, i) => (
            <div key={i} className="p-6 bg-sky-50 rounded-xl border border-sky-100">
              <p className="text-gray-700 italic mb-3">"{s.quote}"</p>
              <p className="font-semibold text-gray-900">{s.name}</p>
              <p className="text-sm text-[#094f6f]">{s.uni}</p>
            </div>
          ))}
        </div>
      </Section>

      <Section title="Landlord Stories">
        <div className="space-y-6">
          {[
            { name: 'Michael T.', location: 'Melbourne, VIC', quote: 'I\'ve been listing my three properties near Monash on RentalX for two years now. My vacancy rate has dropped to near zero and I always have serious students enquiring — not time-wasters. The dashboard makes everything easy to manage.' },
            { name: 'Sarah & David L.', location: 'Sydney, NSW', quote: 'We upgraded to Pro last year and the priority placement made a real difference. We fill all four of our properties within days of listing them now. The verified badge also gives students confidence to book without viewing in person.' },
          ].map((s, i) => (
            <div key={i} className="p-6 bg-emerald-50 rounded-xl border border-emerald-100">
              <p className="text-gray-700 italic mb-3">"{s.quote}"</p>
              <p className="font-semibold text-gray-900">{s.name}</p>
              <p className="text-sm text-emerald-700">{s.location}</p>
            </div>
          ))}
        </div>
      </Section>

      <Section title="By the Numbers">
        <CardGrid items={[
          { title: '50,000+ Students', desc: 'Have used RentalX to find accommodation across Australia.' },
          { title: '4.8 / 5 Average Rating', desc: 'Based on 12,000+ verified reviews from students and landlords.' },
          { title: '95% Fill Rate', desc: 'Pro landlords fill their properties within 2 weeks of listing on average.' },
          { title: '40+ Partner Universities', desc: 'Australian universities recommend RentalX to their incoming students.' },
        ]} />
      </Section>
    </StaticPage>
  );
}
